import { render, staticRenderFns } from "./PressureWidgetV2.vue?vue&type=template&id=1f2f8ff6&scoped=true&"
import script from "./PressureWidgetV2.vue?vue&type=script&lang=ts&"
export * from "./PressureWidgetV2.vue?vue&type=script&lang=ts&"
import style0 from "./PressureWidgetV2.vue?vue&type=style&index=0&id=1f2f8ff6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f2f8ff6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VBtnToggle } from 'vuetify/lib/components/VBtnToggle';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VBtnToggle,VCol,VRow})
